export default __webpack_public_path__ + "static/media/NC.2ebfe259.svg";